import { useState } from "react";
import { motion } from "framer-motion";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { FadeUp, ChapterHeading } from "@/components/Reveal";

const PHOTOS = [
  { src: "/assets/vedete/v01.jpg", caption: "La un pahar de vorbă" },
  { src: "/assets/vedete/v02.jpg", caption: "Oaspete de seamă, măsurat cu ochii" },
  { src: "/assets/vedete/v03.jpg", caption: "Discuții serioase la grătar" },
  { src: "/assets/vedete/v04.jpg", caption: "Lângă cuptor, ca între prieteni" },
  { src: "/assets/vedete/v05.jpg", caption: "Tricoul roșu se poartă" },
  { src: "/assets/vedete/v06.jpg", caption: "Masă plină, veselie mare" },
  { src: "/assets/vedete/v07.jpg", caption: "Sub bereta protectoare" },
  { src: "/assets/vedete/v08.jpg", caption: "Pe terasă, la povești" },
  { src: "/assets/vedete/v09.jpg", caption: "Doi berete roșii, zero sfârșit de masă" },
  { src: "/assets/vedete/v10.jpg", caption: "Cu toată familia la Mitică" },
  { src: "/assets/vedete/v11.jpg", caption: "Zâmbete la umbrelă" },
  { src: "/assets/vedete/v12.jpg", caption: "Vizită oficială, papanași neoficiali" },
  { src: "/assets/vedete/v13.jpg", caption: "Echipa câștigătoare" },
  { src: "/assets/vedete/v14.jpg", caption: "Prieteni de peste hotare" },
  { src: "/assets/vedete/v15.jpg", caption: "Cinstit și cu steag" },
  { src: "/assets/vedete/v16.jpg", caption: "Sub tricolor, la o masă românească" },
  { src: "/assets/vedete/v17.jpg", caption: "La grătar, cu doamnele" },
  { src: "/assets/vedete/v18.jpg", caption: "Desert și zâmbete" },
  { src: "/assets/vedete/v19.jpg", caption: "La masă, ca între vechi prieteni" },
  { src: "/assets/vedete/v20.jpg", caption: "Trei generații de pofticioși" },
  { src: "/assets/vedete/v21.jpg", caption: "Pe terasă, sub privirea beretei" },
  { src: "/assets/vedete/v22.jpg", caption: "Oaspeți înalți, mese și mai mari" },
  { src: "/assets/vedete/v23.jpg", caption: "Aprobarea oficială: degetul în sus" },
  { src: "/assets/vedete/v24.jpg", caption: "Echipa roșie, mereu în priză" },
  { src: "/assets/vedete/v25.jpg", caption: "Selfie de final de masă" },
  { src: "/assets/vedete/v26.jpg", caption: "Sub semnul beretei roșii" },
  { src: "/assets/vedete/v27.jpg", caption: "Oaspeți cu zâmbet mare" },
  { src: "/assets/vedete/v28.jpg", caption: "Sfaturi între mâncători de meserie" },
  { src: "/assets/vedete/v29.jpg", caption: "La masă cu prietenii casei" },
  { src: "/assets/vedete/v30.jpg", caption: "Meciul se vede mai bine cu mici" },
];

export const CelebrityWall = () => {
  const [active, setActive] = useState(null);
  return (
    <section id="oaspeti" className="grain relative bg-[#FAF6F0] py-24 text-stone-800 sm:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <ChapterHeading num="04" title="Peretele de onoare" />
        <FadeUp className="mt-6 max-w-2xl">
          <h2 className="font-display text-3xl font-bold sm:text-5xl">
            Au trecut pe la <span className="italic text-red-600">Nea Mitică</span>
          </h2>
          <p className="mt-4 text-base leading-relaxed text-stone-600 sm:text-lg">
            Vedete, oameni de televiziune și prieteni mari ai casei. Toți au plecat cu burta plină și cu o poză pe perete.
          </p>
        </FadeUp>

        <div className="mt-12 grid grid-cols-2 gap-5 sm:grid-cols-3 lg:grid-cols-6" data-testid="celebrity-wall">
          {PHOTOS.map((p, i) => (
            <motion.button
              key={p.src}
              data-testid={`celebrity-photo-${i}`}
              onClick={() => setActive(p)}
              initial={{ opacity: 0, y: 30, rotate: 0 }}
              whileInView={{ opacity: 1, y: 0, rotate: i % 2 === 0 ? -1.5 : 1.5 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.7, delay: (i % 6) * 0.07, ease: [0.22, 1, 0.36, 1] }}
              whileHover={{ rotate: 0, scale: 1.04, zIndex: 10 }}
              className="group relative rounded-lg bg-white p-2 pb-8 shadow-md transition-shadow hover:shadow-xl"
            >
              <img
                src={p.src}
                alt={p.caption}
                loading="lazy"
                className="aspect-square w-full rounded-sm object-cover"
              />
              <p className="font-hand absolute inset-x-2 bottom-1 truncate text-center text-base text-stone-600">
                {p.caption}
              </p>
            </motion.button>
          ))}
        </div>
      </div>

      <Dialog open={!!active} onOpenChange={() => setActive(null)}>
        <DialogContent data-testid="celebrity-lightbox" className="max-w-3xl border-stone-800 bg-[#121110] p-2">
          {active && (
            <div>
              <img src={active.src} alt={active.caption} className="max-h-[75vh] w-full rounded-xl object-contain" />
              <p className="font-hand p-3 text-xl text-red-300">{active.caption}</p>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </section>
  );
};
